import { Badge, Card, CardBody, HStack, Text, Textarea, VStack } from "@chakra-ui/react";
import { useState } from "react";

export default function AdditionalDataField({
  filters,
  handleApplyFilters,
  isRequired,
  isRTL,
  t,
}) {
  const [localValue, setLocalValue] = useState(filters.additionalData);

  return (
    <Card bg="white" border="1px solid" borderColor="gray.200" borderRadius="md" boxShadow="sm" mt={1}>
      <CardBody p={2}>
        <VStack spacing={1} align="stretch">
          <HStack justify="space-between" align="center">
            <Text fontSize="xs" fontWeight="semibold" color="gray.700">
              {t("reports.additionalData", "البيانات الإضافية")}
            </Text>
            <Badge colorScheme={isRequired ? "blue" : "gray"} variant="subtle" fontSize="xs">
              {isRequired ? t("reports.required", "مطلوب") : t("reports.optional", "اختياري")}
            </Badge>
          </HStack>
          <Text fontSize="xs" color="gray.600">
            {t("reports.additionalDataDesc", "أدخل أي معلومات إضافية ترغب في تضمينها في التحليل")}
          </Text>
          <Textarea
            value={localValue}
            onChange={(event) => setLocalValue(event.target.value)}
            onBlur={() => handleApplyFilters({ additionalData: localValue })}
            placeholder={t("reports.placeholder", "أدخل بيانات إضافية...")}
            size="sm"
            minH="20px"
            bg="white"
            borderColor={isRequired && !localValue ? "orange.300" : "gray.300"}
            resize="vertical"
            textAlign={isRTL ? "right" : "left"}
            dir={isRTL ? "rtl" : "ltr"}
          />
        </VStack>
      </CardBody>
    </Card>
  );
}
